import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify, {
    lang: {
        locales: { pt },
        current: 'pt'
    },
    theme: {
        //TODO cadastrar as cores do sistema pra usar de forma consistente
        primary: '#0067A5', //'#4a9246',
        secondary: '#2196F3',//'#0067EE'//'#ed8732'
        'botao-cancelar-color': '#9F9F9F',
        'text-cinza': '#777777',
        'color-cinza-escuro-1': '#757575',
        'color-cinza-escuro-2': '#616161',
        'color-cinza-escuro-3': '#424242',
        'color-cinza-escuro-4': '#212121',
    },
    options: {
        customProperties: true
    }
})
